import {getTempShareLookUrl} from '../../api/attachment';
import E from "wangeditor"


export const mixin = {
  data: function () {
    return {
      editor: null,
      tempFilesList:[],
      filesList: [],
      formalFiles:{},
      formalFileIds:[],
      deleteFilesList:[],
      uploadActionUrl: ''
    }
  },
  components: {
    E
  },
  props: {
    id: {
      type: String,
      default: function(){
        return 'full-editor_'+new Date().getTime()
      }
    },
    content: {
      type: String,
      default: function(){
        return ''
      }
    },
    businessKey: {
      type: String,
      default: function(){
        return ''
      }
    },
    pictureXtype: {
      type: String,
      default: function(){
        return 'full-editor'
      }
    }
  },
  computed:{

  },
  created () {
    // console.log('-----created----'+this.id,this.content);
    // console.log('-----mounted----'+this.id);
  },
  mounted () {
    /*let obj = {
      id:1,
      auth:[{id:1,name:'ss'}]
    };
    let auth = obj.auth;
    delete obj.auth;
    console.log('---',auth,obj,JSON.stringify(auth));*/
    let editor = new E("#"+this.id);

    // 配置菜单栏，设置不需要的菜单
    editor.config.excludeMenus = [
      'emoticon',
      'video'
    ];
    this.uploadActionUrl = this.util.getBaseUrl() + '/api_v1/files/temp' ;

    editor.config.uploadImgServer = this.uploadActionUrl;
    editor.config.uploadImgParams = {

      xtype: this.pictureXtype
    };
    editor.config.uploadImgHeaders = {
      Authorization: this.sessionUtil.getAccessToken(),
    };
    // 跨域上传中如果需要传递 cookie 需设置 withCredentials 。
    editor.config.withCredentials = false;
    editor.config.zIndex = 10;
    editor.config.uploadFileName = 'file';
    editor.config.uploadImgTimeout = 60 * 1000;
    let _this = this;
    editor.config.uploadImgHooks = {
      // 上传图片之前
      before: function(xhr) {
        console.log(xhr);

        // 可阻止图片上传
        return {
          prevent: false,
          msg: '需要提示给用户的错误信息'
        }
      },
      // 图片上传并返回了结果，图片插入已成功
      success: function(xhr) {
        console.log('success', xhr)
      },
      // 图片上传并返回了结果，但图片插入时出错了
      fail: function(xhr, editor, resData) {
        console.log('fail', resData)
      },
      // 上传图片出错，一般为 http 请求的错误
      error: function(xhr, editor, resData) {
        console.log('error', xhr, resData)
      },
      // 上传图片超时
      timeout: function(xhr) {
        console.log('timeout')
      },
      // 图片上传并返回了结果，想要自己把图片插入到编辑器中
      // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
      customInsert: function(insertImgFn, result) {
        // result 即服务端返回的接口
        console.log('customInsert', result);
        if(result && result.status === 200 && result.data){
          let file = result.data;
          let url = getTempShareLookUrl(file.id,false,file.fileName);
          _this.tempFilesList.push(file);
          // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
          insertImgFn(url);
        }
      }
    };

    this.editor = editor;
    this.editor.create();
    this.tempFilesList = [];
    this.deleteFilesList = [];
    this.filesList = [];
    this.formalFileIds = [];
    if(this.validUtil.isNotNull(this.content)){
      this.setContent(this.content);
    }

    this.loadFile();
    // console.log();
  },
  methods: {
    getContent(){
      let html = this.editor.txt.html();

      let baseUrl = this.util.getBaseUrl();
      // 查找附件
      let c = document.createElement('div');
      c.id = 'div_'+this.id;
      c.innerHTML = html;
      this.filesList = [];
      let imgs = c.getElementsByTagName("img");
      // console.log('---getContent--',imgs);
      let formalFileIds = JSON.parse(JSON.stringify(this.formalFileIds));
      if(imgs && imgs.length>0){
       for(let i = 0;i<imgs.length;i++){
         let img = imgs[i];
         let src = img.src;
         src = src.replaceAll(baseUrl, '');
         // console.log(baseUrl+'-----'+src);
         console.log('-----'+src);
          // 判断是否临时文件
          if(src.startWith('/share/temp/')){
            let id = src.substring(12,src.indexOf('/look'));
            // console.log(id+'--id--'+img.src);
            let f = this.tempFilesList.find(item=>{
              return item.id === id;
            });
            if(f){
              this.filesList.push(f);
            }
          }else if(src.startWith('/share/')){
            // 表示正式文件
            let id = src.substring(7,src.indexOf('/look'));
            // console.log(id+'--id--'+img.src);
            formalFileIds = this.util.removeArr(formalFileIds,id);
          }
        }
      }
      // 替换url
      if(html.indexOf(baseUrl) > -1){
        html = html.replaceAll(baseUrl, '');
      }
      this.deleteFilesList = formalFileIds;
      // 还需要把临时路径改为正式的
      html = html.replaceAll('src="/share/temp/','src="share/');
      return html;
    },
    setContent(html){
      //console.log('------setContent------',html);
      let baseUrl = this.util.getBaseUrl();
      html = html.replaceAll('src="share/temp','src="'+baseUrl+'/share/temp');
      html = html.replaceAll('src="share/','src="'+baseUrl+'/share/');
      html = html.replaceAll('src="/share/','src="'+baseUrl+'/share/');

      //console.log('------setContent---22---',html);
      this.editor.txt.html(html) ;// 重新设置编辑器内容
    },
    getFilesList(){ // 获取待保存图片
      // console.log('------getFilesList-----',this.filesList);
      return this.filesList;
    },
    getDeleteFilesList(){ // 获取待删除图片
      return this.deleteFilesList;
    },
    loadFile() {
      this.formalFiles = {};
      this.formalFileIds = [];
      let _this = this;
      // console.log('-----loadFile------', this.businessKey);
      this.util.restGet('/api_v1/files', {parentId: this.businessKey, xtype: this.pictureXtype}, function (res) {
        if (res.status == 200) {
          if (res.data != undefined && res.data.length > 0) {
            res.data.forEach(f=>{
              _this.formalFiles[f.id] = f;
              _this.formalFileIds.push(f.id);
            })
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/full-editor/index.js